import React, { CSSProperties } from 'react';
import cx from 'clsx';
import { InView } from '../in-view';

interface IAppearProps {
    children?: JSX.Element | JSX.Element[];
    className?: string;
    style?: CSSProperties;
    delay?: number;
    disable?: boolean;
    repeat?: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    dangerouslySetInnerHTML?: {
        __html: string;
    };
}

const minDelayValue = 100;

export const Appear: React.FC<IAppearProps> = React.memo(({
    children,
    className,
    style = {},
    delay = 0,
    disable = false,
    repeat = false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick = () => {},
    dangerouslySetInnerHTML
}: IAppearProps): JSX.Element => {
    const hasChildren = typeof children !== 'undefined';

    if (disable) {
        return (
            <div
                className="appear-element appear-element--disabled"
                onClick={onClick}
                dangerouslySetInnerHTML={!hasChildren && typeof dangerouslySetInnerHTML !== 'undefined' ? dangerouslySetInnerHTML : undefined}
            >
                {children}
            </div>
        )
    }
    const styleObject = {
        transitionDelay: `${delay + minDelayValue}ms`,
    };

    // Combine objects. TransitionDelay from style will override default delay from styleObject if present
    Object.assign(styleObject, style);

    return (
        <InView singleFire={!repeat}>
            {({ inView, ref }): JSX.Element => (
                <div
                    ref={ref}
                    className={cx('appear-element', (className || ''), {
                        'appear-element--will-change': !disable,
                        'appear-element--visible': inView
                    })}
                    style={styleObject}
                    onClick={onClick}
                    dangerouslySetInnerHTML={!hasChildren && typeof dangerouslySetInnerHTML !== 'undefined' ? dangerouslySetInnerHTML : undefined}
                >
                    {children}
                </div>
            )}
        </InView>
    );
});
